// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"738":"787be2fc","986":"d997c8ab"}[chunkId] + ".chunk.js");